"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Card = _interopRequireDefault(require("../../Card/Card"));
var _ComponentWrapper = _interopRequireDefault(require("../../helpers/ComponentWrapper"));
var _constants = require("../../constants");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var FlexInfoCards = function FlexInfoCards(_ref) {
  var infoCards = _ref.infoCards;
  return /*#__PURE__*/_react["default"].createElement(_ComponentWrapper["default"], null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(infoCards.length < 3 && 'max-width-sm margin-auto', " d8-l-auto-grid")
  }, infoCards.map(function (card) {
    return /*#__PURE__*/_react["default"].createElement(_Card["default"], {
      key: JSON.stringify(card),
      template: "ImageCard",
      imageCardTemplate: "VerticalSplit",
      heading: card.title,
      subheading: card.text,
      image: card.image,
      cta: _objectSpread(_objectSpread({}, card.link), {}, {
        iconFlip: true,
        icon: 'arrow-right',
        buttonType: _constants.BUTTON_TYPES.BARE
      })
    });
  })));
};
FlexInfoCards.propTypes = {
  infoCards: _propTypes["default"].array.isRequired
};
var _default = exports["default"] = FlexInfoCards;